import {StoreType} from '..';
import {
  IAdminAllOrganizationsResponse,
  IAdminInfo,
  IAdminOrganizationResponse,
  IAdminAllTransactionsResponse,
  IAdminAllEventsResponse,
  IAdminStatisticResponse,
} from '@/utils/types/superAdmin.interface';

export const getSuperAdminSelector = (state: StoreType): IAdminInfo | null => state.superAdminStore.superAdminInfo;

export const getUserIdSelector = (state: StoreType): number | undefined => state.superAdminStore.superAdminInfo?.id;

export const getUserIsLoadingSelector = (state: StoreType): boolean => state.superAdminStore.isLoading;

export const getOrganizationsListSelector = (state: StoreType): IAdminAllOrganizationsResponse | null =>
  state.superAdminStore.organizationList;

export const getOrganizationSelector = (state: StoreType): IAdminOrganizationResponse | null =>
  state.superAdminStore.organization;

export const getTransactionsListSelector = (state: StoreType): IAdminAllTransactionsResponse | null =>
  state.superAdminStore.transactionList;

export const getEventsListSelector = (state: StoreType): IAdminAllEventsResponse | null =>
  state.superAdminStore.eventsList;

export const getStatisticSelector = (state: StoreType): IAdminStatisticResponse | null =>
  state.superAdminStore.statistic;

export const platformFeeSelector = (state: StoreType): number =>
  state.superAdminStore.platformFee;

